import { PositionType } from './Tooltip';
import { InternalArrow, InternalOffset } from './TooltipContainer';

export const isOnAxis = (position: PositionType) => ({
  y: position === 'top' || position === 'bottom',
  x: position === 'left' || position === 'right',
});

export const arrangePositioningStyles = (
  top: string,
  left: string,
  right: string,
  height: string,
  width: string
) => ({ top, left, right, height, width });

export const extractPositioningStyles = (positionSide: PositionType) => {
  switch (positionSide) {
    case 'bottom':
      return arrangePositioningStyles('100%', '0px', '', '', '100%');
    case 'top':
      return arrangePositioningStyles('', '0px', '', '', '100%');
    case 'right':
      return arrangePositioningStyles('0px', '100%', '', '100%', '');
    default:
      return arrangePositioningStyles('0px', '', '100%', '100%', '');
  }
};

export const removePixels = (str: string) => {
  if (str.indexOf('px') !== -1) {
    return Number(str.slice(0, -2));
  }
  return Number(str);
};

export const arrangeOffset = (
  down: string,
  up: string,
  left: string,
  right: string
): InternalOffset => {
  const downOffset = removePixels(down);
  const upOffset = removePixels(up);
  const leftOffset = removePixels(left);
  const rightOffset = removePixels(right);

  return {
    down: downOffset,
    up: upOffset,
    left: leftOffset,
    right: rightOffset,
    hasNegative:
      downOffset < 0 || upOffset < 0 || leftOffset < 0 || rightOffset < 0,
  };
};

export const extractOffset = (
  onAxis: any,
  down: string,
  up: string,
  left: string,
  right: string
) => {
  const offsets = arrangeOffset(down, up, left, right);

  if (onAxis.x) {
    if (!offsets.hasNegative) {
      offsets.down *= 2;
      offsets.up *= 2;
    }
  }
  if (onAxis.y && !offsets.hasNegative) {
    offsets.right *= 2;
    offsets.left *= 2;
  }

  return offsets;
};

export const calculateVPosition = (
  perc: number,
  elHeight: number,
  divider: number,
  adjMove: number,
  totHeight: number = null
) =>
  `calc(${perc}% - ${totHeight || 0}px - ${elHeight}px/${divider} + ${
    adjMove || 0
  }px)`;

export const calculateTopPosition = (elHeight: number, totHeight: number) =>
  calculateVPosition(50, elHeight, 2, null, totHeight);

export const calculateContentPosition = (
  arrow: InternalArrow,
  position: PositionType,
  firstHeight: number,
  lastHeight: number,
  totalHeight: number
) => {
  let left = '';
  let right = '';
  let top = '10px';
  switch (arrow.position) {
    case 'h-start': {
      left = `calc(50% - 40px)`;
      break;
    }
    case 'h-end': {
      right = `calc(50% - 40px)`;
      break;
    }
    case 'v-start':
      top = calculateTopPosition(firstHeight, null);
      break;
    case 'v-end':
      top = calculateTopPosition(-lastHeight, totalHeight);
      break;
    case 'v-center':
      top = `calc(50% - ${totalHeight}px/2)`;
      break;
    default:
      break;
  }

  switch (position) {
    case 'top':
      top = calculateVPosition(0, totalHeight, 1, 13);
      break;
    case 'left':
      right = '8px';
      break;
    case 'right':
      left = '8px';
      break;
    default:
      break;
  }

  return {
    top,
    left,
    right,
  };
};

export const calculateContentWidth = (initialWidth, offsets) => {
  let contentWidth: string | number = initialWidth;

  if (contentWidth !== 'auto') {
    contentWidth = removePixels(initialWidth);
    if (offsets.left > 0) {
      contentWidth += offsets.left;
    }
    if (offsets.right > 0) {
      contentWidth += offsets.right;
    }
  }

  return contentWidth;
};
